/* eslint-disable */ import { $DomainEntityReflection, EnhancedAliasReflection } from '@salsita-ai/platform-project-sdk/domain';
import { Admin, Countersink, CustomMaterial, DummyDoNotUse, FeatureSetting, Preset, PresetCategory, Recipe } from './admin-model/index.js';
export const constants = {};
const PresetCategoryExpressions = [
    '$isDraft',
    '$admin',
    '$presets'
];
const CustomMaterialExpressions = [
    '$rawMaterialOptions',
    '$finishOptions'
];
const FeatureSettingExpressions = [
    '$plateTypeOptions',
    '$featureTypeOptions',
    '$anchorPointPositionOptions',
    '$violations'
];
const AdminExpressions = [
    '$customMaterials',
    '$countersinks',
    '$featureSettings',
    '$presets',
    '$presetCategories',
    '$recipes'
];
const PresetExpressions = [
    '$admin',
    '$category',
    '$violations'
];
const RecipeExpressions = [
    '$admin'
];
export const $Admin = new $DomainEntityReflection('Admin', [
    ...AdminExpressions
]);
export const $Preset = new $DomainEntityReflection('Preset', [
    ...PresetExpressions
]);
export const $PresetCategory = new $DomainEntityReflection('PresetCategory', [
    ...PresetCategoryExpressions
]);
export const $Recipe = new $DomainEntityReflection('Recipe', [
    ...RecipeExpressions
]);
export const $DummyDoNotUse = new $DomainEntityReflection('DummyDoNotUse', []);
export const $CustomMaterial = new $DomainEntityReflection('CustomMaterial', [
    ...CustomMaterialExpressions
]);
export const $Countersink = new $DomainEntityReflection('Countersink', []);
export const $FeatureSetting = new $DomainEntityReflection('FeatureSetting', [
    ...FeatureSettingExpressions
]);
export const $AnyDomainEntity = new EnhancedAliasReflection('$AnyDomainEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type,
    DummyDoNotUse.type,
    CustomMaterial.type,
    Countersink.type,
    FeatureSetting.type
]);
export const $RootEntity = new EnhancedAliasReflection('$RootEntity', [
    Admin.type
]);
export const $CommonAdminEntity = new EnhancedAliasReflection('$CommonAdminEntity', [
    Admin.type,
    Preset.type,
    PresetCategory.type,
    Recipe.type
]);
export const $entityReflections = {
    Admin: $Admin,
    Preset: $Preset,
    PresetCategory: $PresetCategory,
    Recipe: $Recipe,
    DummyDoNotUse: $DummyDoNotUse,
    CustomMaterial: $CustomMaterial,
    Countersink: $Countersink,
    FeatureSetting: $FeatureSetting
};

//# sourceMappingURL=admin-enhanced-model.js.map